<template>
  <div
    class="v-dialog fixed items-center inset-0 overflow-hidden p-2 justify-center"
    :class="{'flex opacity-100 z-50': show, 'hidden opacity-0': !show, [`v-dialog-${item.size}`]: item.size}"
  >
    <div
      :class="{'inset-0 absolute cursor-default block': show}"
      class="v-dialog-overlay"
      @click="onClose()"
    />
    <div class="v-dialog-container flex flex-col w-full bg-white text-gray-900 shadow-md p-4 z-50">
      <div class="v-dialog-header p-4">
        <button
          type="button"
          class="v-dialog-btn v-dialog-btn-close appearance-none h-5 w-5 float-right leading-0"
          aria-label="Fechar"
          @click="onClose()"
        >
          &#10005;
        </button>
        <div
          v-if="item.title"
          class="v-dialog-title text-bold text-lg"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="v-dialog-body overflow-y-auto p-4 relative">
        <div class="content">
          <div>{{ item.message }}</div>
          <form
            v-if="item.prompt"
            @submit.prevent="onOk"
          >
            <div
              :is="item.prompt.component"
              ref="prompt"
              v-model="item.prompt.value"
              class="v-dialog-input"
              @input="onPrompt"
            />
            <div
              v-if="!valid"
              class="prompt-error-message bg-red-400"
            >
              {{ item.prompt.invalidMessage }}
            </div>
          </form>
        </div>
      </div>
      <div class="v-dialog-footer p-4 text-right">
        <button
          type="button"
          class="v-dialog-btn success appearance-none px-4 py-2 font-bold"
          :class="{disabled: !valid}"
          :disabled="!valid"
          @click="onOk"
        >
          {{ item.okLabel }}
        </button>
        <button
          v-if="item.cancelLabel"
          type="button"
          class="v-dialog-btn bg-orange-800 text-white appearance-none border-0 cursor-pointer v-dialog-btn-danger mr-2 px-4 py-2 font-bold"
          @click="onClose(false)"
        >
          {{ item.cancelLabel }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      valid: this.isValid()
    }
  },

  methods: {
    isValid () {
      if (this.item.prompt) {
        return this.$refs.prompt && this.$refs.prompt.isValid()
      }
      return true
    },

    onPrompt () {
      setTimeout(() => { this.valid = this.isValid() })
    },

    onClose (response) {
      this.$emit('close', this.item, response)
    },

    onOk () {
      if (this.valid) {
        this.onClose(true)
      }
    }
  }

}
</script>

<style>
    .v-dialog.flex .v-dialog-overlay,
    .v-dialog:target .v-dialog-overlay {
        background: rgba(0, 0, 0, .75);
    }

    .v-dialog-container {
        max-height: 75vh;
        max-width: 640px;
    }

    .v-dialog-container .v-dialog-btn.disabled,
    .v-dialog-container .v-dialog-btn:disabled,
    .v-dialog-container .v-dialog-btn[disabled] {
        cursor: default;
        opacity: .5;
        pointer-events: none
    }
</style>
